var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * Module dependencies
 */
var legacyCrypto = require('crypto');

var SubtleCrypto = require('./SubtleCrypto');

var _require = require('./errors'),
    QuotaExceededError = _require.QuotaExceededError,
    TypeMismatchError = _require.TypeMismatchError;
/**
 * integerTypes
 */


var integerTypes = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array];
/**
 * integerGetByConstructor
 */

var integerGetByConstructor = {
  'Int8Array': 'getInt8',
  'Uint8Array': 'getUint8',
  'Int16Array': 'getInt16',
  'Uint16Array': 'getUint16',
  'Int32Array': 'getInt32',
  'Uint32Array': 'getUint32'
  /**
   * Crypto interface
   */

};

var Crypto =
/*#__PURE__*/
function () {
  "use strict";

  function Crypto() {
    _classCallCheck(this, Crypto);
  }

  _createClass(Crypto, [{
    key: "getRandomValues",

    /**
     * getRandomValues
     */
    value: function getRandomValues(typedArray) {
      if (!integerTypes.some(function (type) {
        return typedArray instanceof type;
      })) {
        throw new TypeMismatchError();
      }

      var byteLength = typedArray.byteLength;

      if (byteLength > 65536) {
        throw new QuotaExceededError();
      }

      var type = typedArray.constructor;
      var method = integerGetByConstructor[type.name];
      var totalBytes = byteLength * typedArray.length;
      var buffer = legacyCrypto.randomBytes(totalBytes);
      var arrayBuffer = new Uint8Array(buffer);
      var dataView = new DataView(arrayBuffer.buffer);

      for (var byteIndex = 0; byteIndex < totalBytes; byteIndex += byteLength) {
        var integer = dataView[method](byteIndex);
        var arrayIndex = byteIndex / byteLength;
        typedArray[arrayIndex] = integer;
      }

      return typedArray;
    }
    /**
     * subtle
     */

  }, {
    key: "subtle",
    get: function get() {
      return new SubtleCrypto();
    }
  }]);

  return Crypto;
}();
/**
 * Export
 */


module.exports = Crypto;